'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _NavigationMenu = require('./NavigationMenu');

var _NavigationMenu2 = _interopRequireDefault(_NavigationMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Utility functions for creating components that have React Router 4 functionality
// Removes the dependency on react router


/*
	Generates a React component which can be used inside a Router
	as an alternative to React Bootstrap's Breadcrumb.Item.
	Breadcrumb elements' active state will be automatically controlled
	based on the current route.
*/
var GenerateBreadcrumbLink = function GenerateBreadcrumbLink(Route, Link) {
	var BreadcrumbLink = function BreadcrumbLink(_ref) {
		var href = _ref.href,
		    _children = _ref.children,
		    persistent = _ref.persistent;
		return _react2.default.createElement(Route, {
			path: href
			// eslint-disable-next-line react/no-children-prop
			, children: function children(_ref2) {
				var match = _ref2.match;

				if (!match && !persistent) {
					return null;
				}
				var active = match && match.isExact;
				return _react2.default.createElement(
					'li',
					{ className: (0, _classnames2.default)({ active: active }) },
					active ? _children : _react2.default.createElement(
						Link,
						{ to: href },
						_children
					)
				);
			}
		});
	};

	BreadcrumbLink.propTypes = {
		/* Link target */
		href: _propTypes2.default.string.isRequired,
		/*
  	If true the breadcrumb will show even when the route doesn't match
  	i.e. <BreadcrumbLink href="/foo/bar"> foo/bar </BreadcrumbLink>
  	will render even when at `/foo`
  */
		persistent: _propTypes2.default.bool
	};

	BreadcrumbLink.defaultProps = {
		persistent: false
	};

	return BreadcrumbLink;
};

/*
	Generates a React component which can be used inside a Router
	as an alternative to NavigationMenu.Link.
	The link state will be automatically controlled
	based on the current route, and contains all NavigationMenu.Link enhancements
	such as an icon and notification badge
*/
var GenerateNavLink = function GenerateNavLink(RRNavLink) {
	var NavLink = function NavLink(_ref3, _ref4) {
		var isPrimary = _ref4.isPrimary;

		var href = _ref3.href,
		    icon = _ref3.icon,
		    children = _ref3.children,
		    notifications = _ref3.notifications,
		    notificationStyle = _ref3.notificationStyle,
		    className = _ref3.className,
		    props = _objectWithoutProperties(_ref3, ['href', 'icon', 'children', 'notifications', 'notificationStyle', 'className']);

		return _react2.default.createElement(
			RRNavLink,
			_extends({
				role: 'menuitem',
				className: (0, _classnames2.default)('nav-link', className),
				to: href
			}, props),
			icon && isPrimary && _react2.default.createElement('span', { className: 'gg icon-GG-' + icon }),
			children,
			_react2.default.createElement(_NavigationMenu2.default.NotificationBadge, {
				notifications: notifications,
				bsStyle: notificationStyle
			})
		);
	};

	NavLink.contextTypes = {
		isPrimary: _propTypes2.default.bool
	};

	NavLink.propTypes = {
		/* Link target */
		href: _propTypes2.default.string,
		className: _propTypes2.default.string,
		/* icon class to render e.g. `bug`. Only rendered for primary navs */
		icon: _propTypes2.default.string,
		/**
   * Controls the notification status of the link
   * PropTypes.number: the notification count to display.
   * PropTypes.bool: the notifications
   */
		notifications: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
		/* Badge colour */
		notificationStyle: _propTypes2.default.oneOf(['success', 'info', 'warning', 'danger'])
	};

	return NavLink;
};

var _default = {
	GenerateBreadcrumbLink: GenerateBreadcrumbLink,
	GenerateNavLink: GenerateNavLink
};
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(GenerateBreadcrumbLink, 'GenerateBreadcrumbLink', 'src/components/RouterUtils.jsx');

	__REACT_HOT_LOADER__.register(GenerateNavLink, 'GenerateNavLink', 'src/components/RouterUtils.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/RouterUtils.jsx');
}();

;